// Вписывание страницы PDF в отведённую под превью область.
//
// Раньше ширина страницы считалась формулой, жёстко предполагавшей
// соотношение сторон A4 (высотный бюджет делился на 1.414 = √2). Для
// документа с другим соотношением сторон — чек, длинная узкая квитанция,
// панорамный скан — такая ширина оказывалась слишком большой: при РЕАЛЬНЫХ
// пропорциях страница переставала помещаться по высоте и разъезжалась
// поверх остального интерфейса.
//
// Правильный расчёт (usePdfPageFit.js) берёт соотношение сторон из самого
// PDF и вписывает страницу в бюджет как object-fit: contain — одинаково
// работает и для A4, и для чека.

// A4-портрет — запасное соотношение, пока реальное ещё не известно
// (до ответа pdf.js) или если сам PDF его не отдал.
export const FALLBACK_ASPECT = 1 / Math.SQRT2;

/** Бюджет области превью в пикселях.
 *
 * Считается от размера окна, а не измеряется у родительского контейнера —
 * контейнер превью сам подстраивается под содержимое, и измерять его ради
 * вычисления размера этого же содержимого значит замкнуть цикл (подробнее
 * в докстринге usePdfPageFit.js).
 *
 * Числа те же, что в прежней формуле, — поэтому для обычных A4-документов
 * итоговый размер совпадает с прежним до пикселя: 0.45×ширины окна и
 * 0.5×высоты окна (раньше высотный бюджет тут же делился на √2, то есть
 * неявно предполагал A4; теперь на него делится реальное соотношение сторон). */
export function previewBudget() {
    return {
        width: window.innerWidth * 0.45,
        height: window.innerHeight * 0.5,
    };
}

/** Ширина, при которой страница с соотношением сторон `aspect` (width/height)
 * целиком помещается в прямоугольник boxWidth×boxHeight. */
export function fitWidth(aspect, boxWidth, boxHeight) {
    if (!boxWidth || !boxHeight || !aspect) return 0;
    const widthIfHeightBound = boxHeight * aspect;
    return Math.max(1, Math.floor(Math.min(boxWidth, widthIfHeightBound)));
}

/** Масштаб для альбомного разворота (CSS transform: rotate(90deg)).
 *
 * После поворота на 90° прямоугольник pageWidth×pageHeight визуально
 * становится pageHeight×pageWidth — считаем коэффициент, при котором
 * повёрнутая страница по-прежнему помещается в тот же бюджет
 * boxWidth×boxHeight. Раньше был захардкожен 0.7071 (=1/√2) — он верен
 * ТОЛЬКО для страницы и области с соотношением сторон A4; для чека или
 * любого другого соотношения давал неверный масштаб. */
export function landscapeScale(pageWidth, pageHeight, boxWidth, boxHeight) {
    if (!pageWidth || !pageHeight || !boxWidth || !boxHeight) return 1;
    return Math.min(boxWidth / pageHeight, boxHeight / pageWidth);
}
